import { createContext, useContext, type ReactNode } from "react";
import type { PanelModel } from "@/modules/panel/types";

const PanelContext = createContext<PanelModel | null>(null);

export function PanelProvider({ controller, children }: { controller: PanelModel; children: ReactNode }) {
  return <PanelContext.Provider value={controller}>{children}</PanelContext.Provider>;
}

export function usePanel(): PanelModel {
  const controller = useContext(PanelContext);
  if (!controller) throw new Error("usePanel must be used inside PanelProvider");
  return controller;
}
